<template>
    <div class="fullHeight">
        <MypageSideMenu :memberDropClose="false"/>
        <Card
            :page_title="page_title"
            iconclass="icon-icon-info mypage-title-icon"
            >
            <div class="col-sm-12">
                <p class="text-left">SMSの受信を拒否する携帯番号を入力してください。</p>
                <div class="err_msg" v-if="api_error">
                    <p>
                        <span class="text-danger">{{ this.err_msg_txt}}</span>
                    </p>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3 col-form-label">携帯番号</label>
                    <div class="col-sm-9">
                        <input
                            id="mobile_number"
                            type="text"
                            :class="{'is-invalid': valid.mobile_number}"
                            class="col form-control"
                            v-model="mobile_number"
                            placeholder="半角数字11桁で入力"
                            @blur="checkInputData"
                            @input="checkInputData"
                        />
                        <div
                            class="invalid-feedback"
                            v-if="valid.mobile_number"
                        >{{ valid_message.mobile_number }}</div>
                    </div>
                </div>
                <div class="mb-3">
                    <div class="row justify-content-center">
                        <button
                            type="button"
                            class="bluebackbutton"
                            v-on:click="submitChangeMobile"
                            :disabled="submit_disabled"
                            >
                                設定
                        </button>
                    </div>
                </div>
            </div>
        </Card>
        <MypageMenuFooter/>
    </div>
</template>

<script>
import MypageSideMenu from "./MypageSideMenu";
import validater from "../../lib/validater";
import Card from '../components/Card';
import { REGISTER_SMS_REJECTS } from '../../constants/sms_rejects';
import MypageMenuFooter from './MypageMenuFooter';

export default {
    components: {
        MypageSideMenu,
        MypageMenuFooter,
        validater,
        Card
    },
    data () {
        return {
            page_title: 'SMS受信拒否設定',
            submit_disabled: true,
            valid: {
                mobile_number: false
            },
            valid_message: {
                mobile_number: ""
            },
            api_error: false,
            mobile_number: "",
            err_msg_txt: ""
        };
    },
    methods: {
        /** ----------------------------------------------
         * バリデーションチェック
         * ---------------------------------------------- */
        checkInputData: function(event) {
            if (event.type == "click") {
                // 携帯番号チェック
                this.valid_message.mobile_number = "";
                this.valid.mobile_number = false;
                if (!validater.checkStringLengthMax(event.target.value,11)) {
                    this.valid_message.mobile_number = this.$t("error.validation.length.mobileNumber");
                    this.valid.mobile_number = true;
                } else if (!validater.checkmobilenumber(this.mobile_number)) {
                    this.valid_message.mobile_number = this.$t("error.validation.mobileNumber");
                    this.valid.mobile_number = true;
                }
                // エラー状況をチェック
                if (!this.valid.mobile_number) {
                    return true;
                }
                return false;
            } else if (event.type === "blur"){
                if (!event.target.value) {
                    if (event.target.id === "mobile_number") {
                        // 携帯番号チェック
                        this.valid_message.mobile_number = "";
                        this.valid.mobile_number = false;
                        if (!validater.checkmobilenumber(this.mobile_number)) {
                            this.valid_message.mobile_number = this.$t("error.validation.mobileNumber");
                            this.valid.mobile_number = true;
                        }
                    }
                } else {
                    if (event.target.id === "mobile_number") {
                        // 携帯番号チェック
                        this.valid_message.mobile_number = "";
                        this.valid.mobile_number = false;
                        if (!validater.checkStringLengthMax(event.target.value,11)) {
                            this.valid_message.mobile_number = this.$t("error.validation.length.mobileNumber");
                            this.valid.mobile_number = true;
                        } else if (!validater.checkmobilenumber(this.mobile_number)) {
                            this.valid_message.mobile_number = this.$t("error.validation.mobileNumber");
                            this.valid.mobile_number = true;
                        }
                    }
                }
                this.disabledCheck();
            } else {
                if (event.target.value) {
                    if (event.target.id === "mobile_number") {
                        // 携帯番号チェック
                        this.valid_message.mobile_number = "";
                        this.valid.mobile_number = false;
                        if (!validater.checkStringLengthMax(event.target.value,11)) {
                            this.valid_message.mobile_number = this.$t("error.validation.length.mobileNumber");
                            this.valid.mobile_number = true;
                        } else if (!validater.checkmobilenumber(this.mobile_number)) {
                            this.valid_message.mobile_number = this.$t("error.validation.mobileNumber");
                            this.valid.mobile_number = true;
                        }
                    }
                }
                this.disabledCheck();
            }
        },
        /** ----------------------------------------------
         * 携帯番号を変更ボタン制御処理
         * ---------------------------------------------- */
        disabledCheck: function() {
            if (
                this.mobile_number !== "" && // 全フォームに値があり
                this.valid.mobile_number === false // バリデーションに問題ない場合のみ
            ) {
                this.submit_disabled = false; // ボタン押下可能
            } else {
                this.submit_disabled = true;
            }
        },
        /** ----------------------------------------------
         * 携帯番号変更ボタン押下時処理
         * ---------------------------------------------- */
        submitChangeMobile: async function (event) {
            if (this.checkInputData(event)) {
                this.$store.commit("loading/setIsLoading", true);
                try {
                    let res = await this.$apollo.mutate({
                        mutation: REGISTER_SMS_REJECTS,
                        variables: {
                            mobile_number: this.mobile_number
                        }
                    });

                    if (res.data.registSMSRejects.result === 1) {
                        this.$router.push({ path: '/MypageRejectionSettingComplete' });
                    } else {
                        this.$store.commit("loading/setIsLoading", false);
                    }
                } catch (error) {
                    if (error.graphQLErrors[0].message == "The given data was invalid.") {
                        this.valid.mobile_number = true;
                        this.valid_message.mobile_number = this.$t("error.validation.mobileNumber");
                    } else {
                        this.valid.mobile_number = true;
                        this.valid_message.mobile_number = error.graphQLErrors[0].message;
                    }

                    this.$store.commit("loading/setIsLoading", false);
                }
            }
        }
    }
}

</script>

<style scoped>
</style>
